import PropTypes from "prop-types";
import React from "react";

var InputCheckbox = function InputCheckbox(_ref) {
  var className = _ref.className,
      onChange = _ref.onChange,
      style = _ref.style,
      value = _ref.value;

  return React.createElement("input", {
    className: "token boolean " + className,
    onClick: function onClick(e) {
      return onChange(e.target.checked, e.target.validity.valid);
    },
    style: style,
    type: "checkbox",
    checked: value
  });
};

InputCheckbox.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
  value: PropTypes.bool.isRequired
} : {};

InputCheckbox.defaultProps = {
  className: "",
  style: {}
};

export default InputCheckbox;